export const appLocale = 'pl-PL';
export const numberLocale = 'en-GB';
